<template>
  <div style="height: 100%">

    <div class="site_homePage_title">
      <div style="background-color: #0a84ff" class="site_homePage_title_inner">
        <div class="varchar_size" style="color: whitesmoke">{{'CW制造部' + '' + '型材品质状况'}}</div>
      </div>

      <div class="site_homePage_title_inner">
        <div class="varchar_size">{{this.currentTime}}</div>
        <div class="varchar_size">{{this.week}}</div>
      </div>
    </div>

    <div class="pageContainer">

      <div class="asideContainer" style="border-right: 4px solid whitesmoke">

        <div style="height: 45%;" class="size">

          <div class="title">
            {{'检查概况'}}
          </div>

          <div class="summary">

          <div class="messageCard" style="background-color: rgb(93, 201, 131)">
            <div class="message">{{'即时检查数量'}}</div>
            <h2 style="color: whitesmoke">{{toDayData.totalCnt}}</h2>

          </div>

          <div class="messageCard" style="background-color: rgb(217, 154, 79)">
            <div class="message">{{'即时不良数量'}}</div>
            <h2 style="color: whitesmoke">{{toDayData.totalNgCnt}}</h2>
          </div>

          <div class="messageCard" style="background-color: rgb(212, 109, 72)">
            <div class="message">{{'数量不良率'}}</div>
            <h2 style="color: whitesmoke">{{toDayData.cntNgPercent}}%</h2>
          </div>

          </div>

          <div class="summary">

            <div class="messageCard" style="background-color: rgb(93, 201, 131)">
              <div class="message">{{'即时检查重量'}}</div>
              <h2 style="color: whitesmoke">{{toDayData.totalWeight}}KG</h2>
            </div>

            <div class="messageCard" style="background-color: rgb(217, 154, 79)">
              <div class="message">{{'即时不良重量'}}</div>
              <h2 style="color: whitesmoke">{{toDayData.totalNgWeight}}KG</h2>
            </div>

            <div class="messageCard" style="background-color: rgb(212, 109, 72)">
              <div class="message">{{'重量不良率'}}</div>
              <h2 style="color: whitesmoke">{{toDayData.weightNgPercent}}%</h2>
            </div>
          </div>

        </div>

        <div class="size" style="height: 55%;margin-top: 20px">
          <div class="title">
            {{'供应商别型材不良推移'}}
            <div class="space-between">
              <el-date-picker v-model="supplierBad.year" @change="getSupplierChart" :clearable="false" format="YYYY 年" value-format="YYYY" type="year" placeholder="年" style="width: 100px; margin-right: 10px"/>
              <el-select v-model="supplierBad.supplier" @change="getSupplierChart" :clearable="true" placeholder="供应商" style="width: 220px">
                <el-option
                    v-for="item in suppliers"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div v-loading="supplierChartLoading" element-loading-text="数据加载中" style="margin-top: 20px" class="chart_size" id="siteSupplierXC"/>
        </div>

      </div>

      <div class="asideContainer" style="border-left: 4px solid whitesmoke" >

        <div class="size" style="height:45%;justify-content: space-between">
          <div class="title">
            <span>{{'不良项目占比'}}</span>
            <div class="space-between">
              <el-date-picker @change="getPieChart"  v-model="pieDate.year" :clearable="false" format="YYYY 年" value-format="YYYY" type="year" placeholder="年" style="width: 100px; margin-right: 5px"/>
              <el-date-picker @change="getPieChart"  v-model="pieDate.month" :clearable="false" format="M 月" value-format="M" type="month" placeholder="月" style="width: 80px; margin-right: 5px"/>
<!--              <el-date-picker @change="getPieChart" v-model="currentDay" format="YYYY 年 M 月" :clearable="false" value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 130px;margin-top: 10px"/>-->
              <!--              <el-date-picker v-model="pieDate.day" @change="getPieChart" format="DD 日" value-format="DD" clearable type="day" placeholder="日" style="width: 70px;" size="small"/>-->
            </div>
          </div>
          <div v-loading="pieChartLoading" element-loading-text="数据加载中" style="height: 85%" class="chart_size" id="pieXC"/>
        </div>

        <div class="size" style="height: 55%;margin-top: 20px;">
          <div class="title">{{'受入型材不良堆积图(不良项发生次数)'}}
            <div class="space-between">
              <el-date-picker @change="getDrumChart"  v-model="drumDate.year" :clearable="false" format="YYYY 年" value-format="YYYY" type="year" placeholder="年" style="width: 100px; margin-right: 5px"/>
              <el-date-picker @change="getDrumChart"  v-model="drumDate.month" :clearable="false" format="M 月" value-format="M" type="month" placeholder="月" style="width: 80px; margin-right: 5px"/>
<!--              <el-date-picker @change="getDrumChart" v-model="currentDay" format="YYYY 年 M 月" :clearable="false" value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 130px"/>-->
              <!--              <el-date-picker v-model="drumDate.day" @change="getPieChart" format="DD 日" value-format="DD" clearable type="day" placeholder="日" style="width: 70px;" size="small"/>-->
            </div>
          </div>
          <div v-loading="drumChartLoading" element-loading-text="数据加载中" style="margin-top: 20px" class="chart_size" id="drumXC"/>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { useDateFormat } from '@vueuse/core';
export default {
  name: "XCSiteHomePage",
  data(){
    return{
      toDayData: {},
      currentDay:this.getDateFormat(),
      supplierIndex:0,
      timer:null,
      supplierTime:null,
      pieTime:null,
      currentTime:'',
      week:"星期" + "日一二三四五六".charAt(new Date().getDay()),
      pieDate:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:(new Date().getMonth() + 1).toString(),
        field:'sum(weight)',
        badType:'false',
        day:''
      },
      yAxisName:'不良重量',
      field:'sum(weight)',
      fieldNames:[
        {value:'count(*)',label:'数量'},
        {value:'sum(weight)',label:'重量'}
      ],
      suppliers:[],
      supplierBad:{
        supplier:'',
        field:'sum(weight)',
        year:this.$common.getCurrentYearByMonth().toString(),
      },
      /*不良项目占比*/
      optionPie:{
        title: {
          text: '总数量',
          top: '45%',
          left: '49%',
          textAlign: 'center',
          textStyle: {
            color: 'black',
            fontSize: '26px',
            lineHeight: 30
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          textStyle: {
            fontSize:16
          },
          type: 'scroll',
          orient: 'horizontal',
          top:0,
          data: [
            { value: 1048, name: '二次胶不良' },
            { value: 735, name: '内脏' },
            { value: 580, name: '开裂' },
            { value: 484, name: '变形' },
            { value: 84, name: '擦伤,划伤' },
            { value: 44, name: '膜不良' },
            { value: 84, name: '爆边,爆角' },
            { value: 84, name: 'PVB不良' },
            { value: 44, name: '结石' },
            { value: 44, name: '叠差' },
            { value: 44, name: '表面凹坑' },
            { value: 44, name: '无应力' },
            { value: 44, name: '氩气不足' },
            { value: 300, name: '实物与标签不符' }
          ],
        },
        series: [
          {
            name: '不良项目',
            type: 'pie',
            radius: ['40%', '65%'],
            center: ['50%', '55%'],
            label:{
              show: true,
              fontSize:16,
              formatter: '{b},{d}%'
            },
            data: [
              { value: 44, name: '无应力' },
              { value: 84, name: '擦伤,划伤' },
              { value: 1048, name: '二次胶不良' },
              { value: 44, name: '膜不良' },
              { value: 735, name: '内脏' },
              { value: 44, name: '氩气不足' },
              { value: 84, name: 'PVB不良' },
              { value: 580, name: '开裂' },
              { value: 44, name: '叠差' },
              { value: 484, name: '变形' },
              { value: 44, name: '结石' },
              { value: 84, name: '爆边,爆角' },
              { value: 300, name: '实物与标签不符' },
              { value: 44, name: '表面凹坑' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      pieChartLoading:false,
      /*供应商别不良推移*/
      optionSupplier: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          textStyle: {
            fontSize:16
          }
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        xAxis: [
          {
            type: 'category',
            nameTextStyle: {
              fontSize: 24
            },
            axisLabel: {
              fontSize:18
            },
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良重量',
            nameTextStyle: {
              fontSize: 18
            },
            min:0,
            max:100,
            interval:20,
            axisLabel: {
              fontSize:18,
              formatter: function (value){
                return Number(value.toFixed(0)).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: '不良率',
            nameTextStyle: {
              fontSize: 18
            },
            min:0,
            max:10,
            interval:2,
            axisLabel: {
              fontSize:18,
              formatter: function (value){
                return value.toFixed(1) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '一次不良',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            /*z:"0",/!*控制图形的前后顺序*!/
            barGap:'-50%',/!*用柱子做背景*!/*/
            data: [

            ]
          },
          {
            name: '二次不良',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [

            ]
          },
          {
            name: '目标',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          },
          {
            name: '实绩',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          }
        ]
      },
      supplierChartLoading:false,
      supplierTarget:0,
      /*不良堆积图*/
      optionDrum: {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let res = `${params[0].name} <br/>`
            for (const item of params) {
              if (item.value !== "0") {
                res += `<span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName} : ${item.value}<br/>`
              }
            }
            return res
          },
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          type: 'scroll',
          orient: 'horizontal',
          textStyle: {
            fontSize:16
          },
          data: [],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',nameTextStyle: {
              fontSize: 24
            },
            axisLabel: {
              fontSize: 18,
            },
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良数量',
            nameTextStyle: {
              fontSize: 18
            },
            axisLabel: {
              fontSize: 18,
              formatter: function (value){
                return Number(value.toFixed(0)).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: '日不良率',
            min:0,
            max:15,
            interval:3,
            nameTextStyle: {
              fontSize: 18
            },
            axisLabel: {
              fontSize: 18,
              formatter: function (value){
                return value.toFixed(1) + '%'
              }
            }
          }
        ],
        series: []
      },
      dayBad:{},
      dayLine:[],
      drumChartLoading:false,
      drumDate:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:(new Date().getMonth() + 1).toString(),
        field:'sum(weight)',
        /*day:''*/
      },
    }
  },
  methods: {
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-" + new Date().getDate()
    },

    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        /*let time
        let _this = this
        //chart绑定滚动事件
        chart.on('dataZoom',function (params) {
          //滚动条事件添加防抖
          clearTimeout(time)
          time = setTimeout(()=>{
            _this.getWuJianChartData(params)
          },1000)
        })*/
      }
    },

    renderAllEcharts(){
      if (this.field === 'count(*)'){
        this.yAxisName = '不良数量'
      }
      if (this.field === 'sum(weight)'){
        this.yAxisName = '不良重量'
      }
      this.getSupplierChart()
    },

    async getSuppliers() {
      this.supplierBad.supplier = ''
      let search = {
        method_param_prefix__0:'bus_xingcai_zhijian_info.supplier_name'
      }
      let {data: res} = await this.$axios.post('bus/datasource/getBoLiSupplier',search);
      if (res.code !== 0) {
        this.$message.error('获取供应商失败')
        return;
      }
      this.suppliers = res.data;
      for (let i = this.suppliers.length - 1; i >= 0 ; i--) {
        if (this.suppliers[i].value === "苏州凯朗德金属科技有限公司" || this.suppliers[i].value === "苏州腾研精密机械有限公司"
            || this.suppliers[i].value === "苏州市瑞林压铸模具厂" || this.suppliers[i].value === "佛山市南燊金属型材制品有限公司"){
          this.suppliers.splice(i,1)
        }
      }

    },

    async getSupplierChart() {
      this.supplierChartLoading = true
      if (!this.supplierBad.year){
        this.supplierBad.year = this.$common.getCurrentYearByMonth().toString()
      }
      /*await this.getSuppliers()
      if (this.supplierIndex === -1){
        this.supplierBad.supplier = ''
      }else {
        this.supplierBad.supplier = this.suppliers[this.supplierIndex].value
      }*/
      let {data: res} = await this.$axios.post('bus/xingcaiCharts/getXingcai04',this.supplierBad);
      console.log(res)
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.optionSupplier.xAxis[0].data = res.data.XMonth
      this.optionSupplier.series[0].data = res.data.badNum
      this.optionSupplier.series[1].data = res.data.badNumTwo
     /* for (let i = 0; i < this.optionSupplier.xAxis[0].data.length; i++) {
        this.optionSupplier.series[2].data.push(this.supplierTarget)
      }*/
      this.optionSupplier.series[2].data = []
      if (res.data[this.supplierBad.year - 1] && res.data[this.supplierBad.year]) {
        for (let i = 0; i < 3; i++) {
          this.optionSupplier.series[2].data.push(res.data[this.supplierBad.year - 1])
        }
        for (let i = 3; i < this.optionSupplier.xAxis[0].data.length; i++) {
          this.optionSupplier.series[2].data.push(res.data[this.supplierBad.year])
        }
      }
      this.optionSupplier.series[3].data = res.data.badPercent
      let a = this.$common.getDivisor(Math.max(...res.data.badNum))
      this.optionSupplier.yAxis[0].max = Math.ceil(Math.max(...res.data.badNum)/a)*a*1.2
      this.optionSupplier.yAxis[0].interval = Math.round(this.optionSupplier.yAxis[0].max/5*100)/100
      /*this.optionSupplier.yAxis[1].max = Math.max(Math.max(...res.data.badPercent),this.supplierTarget) + 5
      this.optionSupplier.yAxis[1].interval = Math.round(this.optionSupplier.yAxis[1].max/5*100)/100*/
      this.optionSupplier.yAxis[0].name = this.yAxisName
      this.renderEcharts('siteSupplierXC',this.optionSupplier)

      this.supplierChartLoading = false

     /* if (this.supplierIndex === this.suppliers.length - 1) {
        this.supplierIndex = -1
      } else {
        this.supplierIndex += 1
      }
      clearInterval(this.supplierTime)
      this.supplierTime = setInterval(() => {
        this.getSupplierChart()
      }, 30000)*/
    },

    async getPieChart() {
      if (!this.pieDate.year){
        this.pieDate.year =  this.$common.getCurrentYearByMonth().toString()
      }
      this.pieChartLoading = true
      let {data: res} = await this.$axios.post('/bus/xingcaiCharts/getXingcai03',this.pieDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.optionPie.legend.data = res.data
      this.optionPie.series[0].data = res.data
      this.optionPie.title.text = "合计\n" + this.$common.getPieSum(this.optionPie.series[0].data).toLocaleString()
      this.renderEcharts('pieXC',this.optionPie)

      this.pieChartLoading = false
    },

    async getDrumChart() {
      if (!this.drumDate.year){
        this.drumDate.year =  this.$common.getCurrentYearByMonth().toString()
      }
      this.drumChartLoading = true
      let {data: res} = await this.$axios.post('bus/xingcaiCharts/getXingcai05',this.drumDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      if (res.data) {
        this.optionDrum.xAxis[0].data = res.data.XDay
        this.optionDrum.series = res.data.drumSeries
        this.dayLine = res.data.ngPercent
        let line = {name: '日不良率', type: 'line', yAxisIndex: 1,
          tooltip: {valueFormatter: function (value) {return value + ' %';}}, data: this.dayLine}
        this.optionDrum.series.push(line)
        this.optionDrum.legend.data = res.data.drumSeries
        let array = res.data.drumSeries
        let total = []
        for (let key in array) {
          array[key].data.forEach((value,index)=>{
            if (this.isBlank(total[index])){
              total[index] = 0
            }
            total[index] += Math.ceil(value)
          })
        }
        this.optionDrum.yAxis[0].name = this.yAxisName
        this.optionDrum.yAxis[0].max = Math.ceil(Math.max(...total)/100)*100
        this.optionDrum.yAxis[0].interval = Math.round(this.optionDrum.yAxis[0].max/5*100)/100
        this.renderEcharts('drumXC', this.optionDrum)
      }

      this.drumChartLoading = false
    },

    isBlank(val){
      if(val == null || val === ""){
        return true;
      }
    },

    async getToDayData() {
      let {data: res} = await this.$axios.get('bus/xingcaiCharts/getXingcai02');
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.toDayData = res.data
    },

    /*async getTargetDict() {
      let {data: res} = await this.$axios.post('bus/datasource/getDictList','home_page');
      if (res.code !== 0) {
        this.$message.error('获取目标值失败')
        return;
      }
      res.data.forEach((item)=>{
        if (item.id === "shouru_xingcai_blend"){
          this.blendTarget = item.name
        }
        if (item.id === "shouru_xingcai_wujian"){
          this.wuJianTarget = item.name
        }
        if (item.id === "shouru_xingcai_supplier"){
          this.supplierTarget = item.name
        }
      })
    },*/

    dateFormat(){
      this.currentTime = useDateFormat(new Date(), 'YYYY年-M月-DD日 HH:mm:ss')
    },

  },

  created() {
    this.getSuppliers()
    this.dateFormat()
    //this.getTargetDict()
    this.getToDayData()
    this.getPieChart()
    this.getDrumChart()
  },

  mounted(){
    this.timer = setInterval(()=>{
      this.dateFormat();
    }, 1000)
    this.renderAllEcharts()

    setInterval(()=>{
      this.getToDayData()
      this.getPieChart()
      this.getDrumChart()
      this.getSupplierChart()
    },20000)
  },

  unmounted() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.supplierTime) {
      clearInterval(this.supplierTime); // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.pieTime) {
      clearInterval(this.pieTime); // 在Vue实例销毁前，清除我们的定时器
    }
  }

}
</script>

<style scoped>
.topContainer{
  display: flex;
  flex-direction: row;
}

.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.space-between{
  display: flex;
  flex-direction: row;
  align-items: center;;
}

.asideContainer{
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.wujian_size{
  width: 940px;
  height: 200px
}

.size{
  height: 40%;
}

.title{
  border-left: 3px solid steelblue;
  width: 80%;
  font-size: 22px;
  padding-left: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.summary{
  width: 80%;
  height: 80%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.messageCard{
  width: 180px;
  height: 105px;
  background-color:whitesmoke;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

margin-right{
  margin-right: 5px;
}

.message{
  font-size: 26px;
  color: whitesmoke;
  border-radius: 5px;
}

.chart_size{
  width: 95%;
  height: 65%;
}
</style>